// extracted by mini-css-extract-plugin
export default {"p":"ea1592e73a _202db49af3 _9d380eefda","clr":"_5a2445da59","dls":"_4165064384"};